import { GetStaticPaths, GetStaticProps } from 'next'
import { ReactElement } from 'react'

import { dehydrate, QueryClient } from 'react-query'

import { getCategories } from 'app/services/Api/blog'
import { blogConfig } from 'app/services/Query/blog/blog.query'
import { NextPage } from 'app/types/decalarations/next'
import {
  hasCategoryInCollection,
  getArticlesQueryParams,
  getFeaturedArticlesQueryParams
} from 'app/utils/helpers/blog.helpers'

import BlogLayout from '~/components/layouts/BlogLayout'
import MainLayout from '~/components/layouts/MainLayout'
import BlogView from '~/views/Blog/BlogView'

const BlogCategoryPage: NextPage = () => <BlogView />

BlogCategoryPage.getLayout = (page: ReactElement) => (
  <MainLayout>
    <BlogLayout withoutContainer>{page}</BlogLayout>
  </MainLayout>
)

export const getStaticPaths: GetStaticPaths = async () => {
  const categories = await getCategories()

  const paths = categories.map(({ slug }) => ({ params: { category: slug } }))

  return { paths, fallback: true }
}

export const getStaticProps: GetStaticProps = async (context) => {
  const category = context.params?.category as string
  const p = context.params?.p as string

  const articleParams = getArticlesQueryParams({ category, p })
  const featuredParams = getFeaturedArticlesQueryParams()

  try {
    const queryClient = new QueryClient()
    const { getCategories, getTags, getArticles } = blogConfig

    const articlesKey = getArticles.key(articleParams)
    const featuredArticlesKey = getArticles.key(featuredParams)

    await queryClient.prefetchQuery(getCategories.key, getCategories.request)

    const categoriesState = queryClient.getQueryState<BlogCategoryModel[]>(
      getCategories.key
    )
    const collection = categoriesState?.data
    const isValidCategoryTab = hasCategoryInCollection({ category, collection })

    if (!isValidCategoryTab) {
      throw new Error('Category not found')
    }

    await queryClient.prefetchQuery(getTags.key, getTags.request)
    await queryClient.prefetchQuery(featuredArticlesKey, getArticles.request)
    await queryClient.prefetchQuery(articlesKey, getArticles.request)

    return {
      props: { dehydratedState: dehydrate(queryClient) }
    }
  } catch (error) {
    return { notFound: true }
  }
}

export default BlogCategoryPage
